export class Manufacturer {
  id: number
  name: string
  phoneNumber: string
  email: string
  website: string

  highlighted: boolean

  constructor(id: number, name: string, phoneNumber: string, email: string, website: string) {
    this.id = id
    this.name = name
    this.phoneNumber = phoneNumber
    this.email = email
    this.website = website

    this.highlighted = false
  }
}
